(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict'

module.exports = isMobile
module.exports.isMobile = isMobile
module.exports.default = isMobile

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i

function isMobile (opts) {
  if (!opts) opts = {}
  var ua = opts.ua
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent']
  }
  if (typeof ua !== 'string') return false

  return opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJSON = getJSON;
exports.hgUrl = void 0;

var _mainVars = require("./main.vars.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

console.log("window from functions");

(function ($) {
  $.fn.hgRender = function (tmpFile, element, data) {
    var attachTo = this;

    if (tmpFile) {
      // se viene usato template
      $.get(tmpFile, function (templates) {
        var $t = $($(templates).filter(element).html());
        $.each(data, function (el, cont) {
          var action = "text";

          if (_typeof(cont) == "object") {
            if (cont.trim) {
              cont.content = cont.content.substring(0, cont.trim, "...");
            }

            if (cont.image) {
              action = "image";
              var image = cont.imgProvider + cont.imgSize + "/" + cont.content.nomeFile;
            }

            if (cont.href) {
              action = "link";
              var hUrl = new Url(cont.href.baseUrl);
              $.each(cont.href.params, function (i, p) {
                hUrl.query[p.key] = p.value;
              });
              var link = hUrl;
            }

            cont = cont.content;
          }

          if (action == "image") {
            $t.find(el).attr("src", image);
          } else if (action == "link") {
            $t.find(el).attr("href", link);
          } else {
            $t.find(el).html(cont);
          }
        });
        $t.appendTo(attachTo);
      });
    } else {
      // se si lavora direttamente sul DOM
      var $t = $(element);
      $.each(data, function (el, cont) {
        if (el == "#struttura-prezzi") {
          console.error("TABELLA PREZZI");
        }

        if (typeof cont.beforeRender === 'undefined') {
          cont.beforeRender = function () {
            return "defaultFunction"; // valore simbolico, giusto per far andare $.when()
          };
        }

        $.when(cont.beforeRender()).done(function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var beforeFnArgs = args;
          console.log("BEFORE FN ARGS", args);

          if (_typeof(beforeFnArgs[0]) == "object") {
            if (typeof beforeFnArgs[0].content != "undefined") {
              cont.content = beforeFnArgs[0].content;
            }
          }

          var action = "text";

          if (_typeof(cont) == "object") {
            if (cont.trim) {
              // cont.content = $(cont.content).text()
              // var contentTmp = cont.content.substring(0, cont.trim, '<a href="#" class="struttura-desc-collapse" data-content="">Altro...</a>')
              // var contentTmp = '<div class="descrizione-trimmed">' + cont.content.substring(0, cont.trim) + '</div>\
              // <div class="descrizione-full"> ' + cont.content + '</div>\
              // <a class="descrizione-collapse" href="#">Altro...</a>'
              var contentTmp = '<div class="descrizione-content">' + cont.content + '</div><a class="descrizione-collapse" href="#">Altro...</a>';
              cont.content = contentTmp;
            }

            if (cont.image) {
              action = "image";
              var image = cont.imgProvider + cont.imgSize + "/" + cont.content.nomeFile;
            }

            if (cont.background) {
              action = "background";
              var image = cont.imgProvider + cont.imgSize + "/" + cont.content.nomeFile;
              console.log("bg 1");
            }

            if (cont.map) {
              cont.content = '<div class="struttura-mappa-values" data-lat="' + cont.lat + '" data-long="' + cont.long + '">struttura-mappa-values</div>';
            }

            if (cont.gallery) {
              action = "gallery";
              var $gallery = $('<div class="hg-gallery"></div>');
              $.each(cont.content, function (i, elem) {
                var thumbnail = cont.sizes.thumbnail.provider + cont.sizes.thumbnail.size + "/" + elem.nomeFile;
                var large = cont.sizes.large.provider + cont.sizes.large.size + "/" + elem.nomeFile;
                $gallery.append('<a class="lightboxgallery-gallery-item" href="' + large + '"><div>\
                <img src="' + thumbnail + '" />\
              </div></a>');
              });
              var sliderOptions = cont.options.slider;
            }

            if (cont.customTemplate) {
              // CUSTOM TEMPLATES
              if (cont.customTemplate == "servizi") {
                // CT servizi
                var sJSON = beforeFnArgs[0];
                var out = "";
                console.log("cont.content", cont.content);
                $.each(cont.content, function (i, serv) {
                  console.log("SERV", serv);

                  if (!cont.link) {
                    var $e = $('<div class="list-elem"></div>');
                  } else {
                    var link = new hgUrl(window.hgObject.pages.list_cataloghi_attuale);
                    link.query.club = serv.id;
                    var $e = $('<a href="' + link + '" class="list-elem"></a>');
                  } // var servidPrefix = serv.id.replace(cont.customTemplateVars.idSubstring, "")


                  var sJthis = sJSON.filter(function (x) {
                    return x.id == cont.customTemplateVars.idSubstring + serv.id;
                  })[0];
                  console.log("sJthis", sJthis);
                  var icon = _mainVars.icons.servizi[serv.id];
                  console.log("icon", icon);
                  var iconUrl = window.hgObject.paths.themeHg + icon;

                  if (typeof icon == "undefined" || icon == "undefined") {
                    // iconUrl = "https://i.ibb.co/y8k5f1t/icons8-service-96.png"
                    iconUrl = window.hgObject.paths.themeHg + '/src/img/clp.svg'; // iconUrl = window.hgObject.paths.themeHg + '/src/img/servizi/clp.svg'
                  }

                  if (cont.tooltips) {
                    // data-toggle="tooltip" title="" data-original-title="
                    $e.attr("data-toggle", "tooltip").attr("data-original-title", sJthis.descrizione);
                  }

                  $e.append('<div><img class="struttura-servizio-icon" src="' + iconUrl + '" /></div>'); // $e.append('<div>' + serv.nome + serv.id + '</div>')

                  $e.append('<div>' + serv.nome + '</div>');
                  out += $e.prop('outerHTML');
                });
                cont.content = out;
              } // END CT servizi

            } // END CUSTOM TEMPLATES


            if (cont.inputValue) {
              action = "input";
            }

            if (typeof cont.afterRender !== 'undefined') {
              var afterRender = cont.afterRender;
            }

            cont = cont.content;
          }

          switch (action) {
            case "background":
              console.log("bg 2");
              $t.find(el).css("background-image", "url(" + image + ")");
              break;

            case "image":
              $t.find(el).attr("src", image);
              break;

            case "gallery":
              console.log("QUI GALLERIA");
              console.log(cont.options);
              $t.find(el).html($gallery);
              $(el).find(".hg-gallery").slick(sliderOptions);
              $(document).on('click', '.lightboxgallery-gallery-item', function (event) {
                event.preventDefault();
                $(this).lightboxgallery({
                  showCounter: true,
                  showTitle: true,
                  showDescription: true
                });
              });
              break;

            case "input":
              $t.find(el).val(cont);
              break;

            default:
              $t.find(el).html(cont);
              break;
          }

          if (afterRender) {
            afterRender();
          }
        }); // end when()
      });
    }
  };
})(jQuery);

var hgUrl =
/*#__PURE__*/
function (_Url) {
  _inherits(hgUrl, _Url);

  function hgUrl() {
    _classCallCheck(this, hgUrl);

    return _possibleConstructorReturn(this, _getPrototypeOf(hgUrl).apply(this, arguments));
  }

  _createClass(hgUrl, [{
    key: "render",
    value: function render() {
      var u = this;
      window.history.pushState('thol', document.title, u);
    }
  }]);

  return hgUrl;
}(Url);

exports.hgUrl = hgUrl;

function getJSON(endpoint, callback, notAsync) {
  // console.group("getJSON")
  var cacheName = "hg_getjson_cache_" + endpoint; // if (localStorage.getItem(cacheName) !== null) {

  if (1 == 2) {
    console.info("getJSON: there is cache");
    callback(JSON.parse(localStorage.getItem(cacheName)));
  } else {
    endpoint = window.hgPaths.data + endpoint + ".json";
    var async = notAsync ? false : true; // console.blue("Hg getJSON async")

    console.log("Endpoint", endpoint); // console.log("Async", async)

    $.ajax({
      type: "GET",
      url: endpoint,
      async: async,
      data: "",
      dataType: "JSON",
      success: function success(response) {
        localStorage.setItem(cacheName, JSON.stringify(response));
        console.info("getJSON: cache saved");
        callback(response); // console.groupEnd();
      }
    });
  }
}

console.log("Functions loaded ");

},{"./main.vars.js":4}],3:[function(require,module,exports){
"use strict";

var _mainVars = require("./main.vars.js");

var _mainFunctions = require("./main.functions.js");

console.group("HgBlu init log");

var mobile = require('is-mobile');

window.hgPaths = {
  data: window.hgObject.paths.themeHg + "/data/" + window.hgObject.catalogo.attuale + "/",
  template: window.hgObject.paths.themeHg + "/templates.htm"
};
/*************
 * MAIN FLOW *
 *************/

var u = new _mainFunctions.hgUrl();
var urlMapping = {
  stars: "id_categoria",
  area: "id_area",
  sottoarea: "id_sottoarea",
  localita: "id_localita"
};
$(function () {
  TooltipsInit();
});
console.log("hgCurrentPage", window.hgCurrentPage); //
// ──────────────────────────────────────────────────────────── I ──────────
//   :::::: P A G E S   I N I T : :  :   :    :     :        :          :
// ──────────────────────────────────────────────────────────────────────
//

if (window.hgCurrentPage == "list") {
  LoaderShow();
  DatafolderAlign();
  searchInit(String(window.hgObject.wpQuery.catalogo));
  Crawl();
  FiltersAlign();
  FiltersOnChange();
  setTimeout(function () {
    FiltersCollapseController();
  }, 1000);
  if (mobile()) MobileListFiltersStyle(); // $(".filter-elem").each(function (index, element) {
  //   FiltersHierarchy_do(element)
  // });
} else if (window.hgCurrentPage == "home") {
  DatafolderAlign();
  searchInit();
} else if (window.hgCurrentPage == "show") {
  urlMapping.id = "id_struttura"; // LoaderShow()

  strutturaGet();
} // ────────────────────────────────────────────────────────────────────────────────
//
// ────────────────────────────────────────────────────────────────────── I ──────────
//   :::::: L I S T A   S T R U T T U R E : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────────────────
//


function Crawl() {
  // console.clear();
  (0, _mainFunctions.getJSON)("zone", function (zr) {
    (0, _mainFunctions.getJSON)("strutture_base", function (r) {
      var initialLen = r.length; // r = FiltersDo(r)

      r = FiltersDo(r);
      ListaRender(r);
      Debug(r, initialLen);
      CountRender(r);
      LoaderHide();
    });
    window.zone = zr;
  });
}

function getCurrentCatalog() {
  console.group("function getCurrentCatalog()");
  var current = window.hgObject.wpQuery.catalogo != null ? window.hgObject.wpQuery.catalogo : window.hgObject.catalogo.attualeUrl; // console.log(window.hgObject.wpQuery.attualeUrl);

  console.log(current);
  console.groupEnd();
  return window.hgObject.catalogo[String(current)];
}

function DatafolderAlign() {
  console.group("function DatafolderAlign()");
  window.hgPaths.data = window.hgObject.paths.themeHg + "/data/" + getCurrentCatalog() + "/", console.log("window.hgPaths.data", window.hgPaths.data);
  console.groupEnd();
}

function ListaRender(resp) {
  // console.log(resp);
  $("#list").empty();
  $("#list-messages .list-msg").css("visibility", "hidden");

  if (resp.length == 0) {
    $("#list-messages").find(".no-strutture").css("visibility", "visible");
  } else {
    resp.forEach(function (e) {
      var club = "";

      if (typeof e.servizi.clp != "undefined") {
        $.each(e.servizi.clp, function (indexInArray, s) {
          // club += s.id + ", "
          if (typeof _mainVars.icons.servizi[s.id] != "undefined") {
            club += '<img class="servizio-icon" src="' + window.hgObject.paths.themeHg + _mainVars.icons.servizi[s.id] + '" />';
          }
        });
      }

      if (typeof e.servizi.ser != "undefined") {
        $.each(e.servizi.ser, function (indexInArray, s) {
          // club += s.id + ", "
          if (typeof _mainVars.icons.servizi[s.id] != "undefined") {
            club += '<img class="servizio-icon" src="' + window.hgObject.paths.themeHg + _mainVars.icons.servizi[s.id] + '" />';
          }
        });
      }

      var nomeStrutturaUrl = e.nomeStruttura.trim().split(" ");
      nomeStrutturaUrl = nomeStrutturaUrl.filter(function (r) {
        return r != "-";
      });
      nomeStrutturaUrl = nomeStrutturaUrl.join("-");
      var data = {
        ".card-link": {
          href: {
            baseUrl: window.hgObject.pages.show + window.hgObject.wpQuery.catalogo + "/" + e.id_struttura + "/" + nomeStrutturaUrl + "/" // params: [{
            //   key: "struttura",
            //   value: e.id_struttura
            // }]

          }
        },
        ".card-title": e.nomeStruttura,
        // '.card-text': {
        //   content: e.descrizione,
        //   trim: 100
        // },
        ".stars": echoStars(e.id_categoria),
        ".area": e.nome_area,
        ".localita": e.nome_localita,
        ".img-featured": {
          content: e.immagini[0],
          image: true,
          imgProvider: "http://img.thol.it/?",
          imgSize: "miniatura1"
        },
        ".club": club
      };
      var params = {};
      $("#list").hgRender(window.hgPaths.template, "#list-elem", data);
    });
  }
}

function MobileListFiltersStyle() {
  var $c = $("#filter-mob-trigger-contaienr");
  var offset = $c.offset().top + $c.height();
  $(document).ready(function () {
    var $sc = $(".sidebar-container");
    var $scParent = $sc.parent(".row");
    var scpMt = $scParent.css("margin-top").replace("px", "");
    var $mh = $("#main-header");
    offset = offset - scpMt - $mh.height();
    console.log("MT", scpMt);
    $(".sidebar-container").css({
      "top": offset + "px" // "visibility": "visible"

    });
  });
  $(".filter-mob-trigger").click(function (e) {
    $(this).siblings(".filter-mob-trigger").each(function (index, el) {
      console.log($(el).attr("class"));
      if ($(el).hasClass("opened")) $(el).removeClass("opened");
    });
    $(".filter-container").css({
      "display": "none"
    }); // $(".filter-mob-trigger").each(function (index, el) {
    //   $(el).removeClass("opened").data('clicks', false);
    // });
    // $(".filter-container").each(function (index, el) {
    //   $(el).css({
    //     "display": "none"
    //   })
    // });

    e.preventDefault();
    var toOpen = $(this).attr("data-href");

    if (!$(this).hasClass("opened")) {
      $(toOpen).css({
        "display": "block"
      });
      $(".sidebar-container").css({
        "visibility": "visible"
      });
      $(this).addClass("opened");
    } else {
      $(toOpen).css({
        "display": "none"
      });
      $(".sidebar-container").css({
        "visibility": "hidden"
      });
      $(this).removeClass("opened");
    } // $(this).toggleClass("opened")
    // var clicks = $(this).data('clicks');
    // if (!clicks) {
    // } else {
    // }
    // $(this).data("clicks", !clicks);

  });
}
/**************
 * FILTERS DO *
 **************/


function FiltersDo(strutture) {
  console.log("%cfunction FiltersDo()", "color: teal");
  var localita = [];
  var categorie = [];
  var tipologie = [];
  var servizi = []; // ZONE
  // 1 - CONTO LE AREE SELEZIONATE

  var totAree = $("input.area:checkbox:checked").length; // console.log('Aree: ' + totAree);

  if (totAree > 0) {
    $("input.area:checkbox:checked").each(function () {
      var temp_id_area = $(this).val();
      console.log("ID area: " + temp_id_area); // 2 - CONTO LE SOTTOAREE SELEZIONATE

      var container_area_id = "#container-area-" + temp_id_area;
      console.log("CONTAINER area: " + container_area_id);
      var totSottoaree = $(container_area_id + " input.sottoarea:checkbox:checked").length;
      console.log("Sottoaree: " + totSottoaree);

      if (totSottoaree > 0) {
        console.log("totSottoaree > 0");
        $(container_area_id + " input.sottoarea:checkbox:checked").each(function () {
          var temp_id_sottoarea = $(this).val();
          console.log("temp_id_sottoarea", temp_id_sottoarea);
          var container_sottoarea_id = "#container-sottoarea-" + temp_id_sottoarea;
          var totLocalita = $(container_sottoarea_id + " input.localita:checkbox:checked").length;

          if (totLocalita > 0) {
            console.log("Prendo le localita selezionate nella sottoarea " + container_sottoarea_id);
            $(container_sottoarea_id + " input.localita:checkbox:checked").each(function () {
              var temp_id_localita = $(this).val();
              localita.push(temp_id_localita);
            });
          } else {
            // OTTIENE ELENCO COMPLETO ID LOCALITÀ
            $(container_sottoarea_id + " input.localita").each(function () {
              var temp_id_localita = $(this).val();
              localita.push(temp_id_localita);
            });
          }
        });
      } else {
        console.log("totSottoaree < 0"); // OTTIENE ELENCO COMPLETO ID LOCALITÀ

        console.log("container_area_id", container_area_id);
        $(container_area_id + " input.localita").each(function () {
          var temp_id_localita = $(this).val();
          localita.push(temp_id_localita); // console.log('Località: ' + temp_id_localita);
        });
      }
    });
  }

  console.log("Località selezionate: " + localita); // ZONE
  // CATEGORIE

  var totCategorie = $("input.categoria:checkbox:checked").length;

  if (totCategorie > 0) {
    $("input.categoria:checkbox:checked").each(function () {
      var temp_id_categoria = $(this).val();
      categorie.push(temp_id_categoria);
    });
    if (categorie.includes("3")) categorie.push("3s");
    if (categorie.includes("4")) categorie.push("4s");

    if (categorie.includes("2") || categorie.includes("3") || categorie.includes("4") || categorie.includes("5")) {
      tipologie.push("H");
    }
  }

  console.log(" Categorie selezionate: " + categorie); // CATEGORIE
  // TIPOLOGIE

  var totTipologie = $("input.tipologia:checkbox:checked").length;

  if (totTipologie > 0) {
    $("input.tipologia:checkbox:checked").each(function () {
      var temp_id_tipologia = $(this).val();
      console.log("%cTipologia:", "color: red", temp_id_tipologia);
      tipologie.push(temp_id_tipologia);
    });

    if (tipologie.includes("A")) {
      tipologie.push("K"); // tipologie.push('H');

      tipologie.push("R");
    }
  }

  console.log(" Tipologie selezionate: " + tipologie); // TIPOLOGIE
  // SERVIZI

  var totServizi = $("input.servizio:checkbox:checked").length;

  if (totServizi > 0) {
    $("input.servizio:checkbox:checked").each(function () {
      var temp_id_servizio = $(this).val();
      servizi.push(temp_id_servizio);
    });
  }

  console.log(" Servizi selezionati: " + servizi); // SERVIZI

  /**************************
   * BEGIN FILTRA STRUTTURE *
   **************************/
  // per localita

  if (localita.length > 0) {
    var res = $.grep(strutture, function (v) {
      return localita.indexOf(v.id_localita) > -1;
    });
  } else {
    var res = strutture;
  } // per categoria (stelle)


  if (categorie.length > 0) {
    var res = $.grep(res, function (v) {
      return categorie.indexOf(v.id_categoria) > -1;
    });
  } // per tipologia (Hotel, residence, etc.)


  if (tipologie.length > 0) {
    res = $.grep(res, function (v) {
      return tipologie.indexOf(v.id_tipologia) > -1;
    });
  }
  /************************
   * END FILTRA STRUTTURE *
   ************************/
  // FILTRA PER SERVIZI


  $.each(servizi, function (i, item) {
    res = res.filter(function (r) {
      return r.servizi_filtro.includes(item);
    });
    console.log("I", item);
  }); // FILTRA PER SERVIZI
  // FILTRA CLUB

  if (u.query.club) {
    res = res.filter(function (r) {
      // console.log(r.servizi_filtro);
      return r.servizi_filtro.includes("clp" + u.query.club);
    });
  } // FILTRA CLUB


  return res;
}
/*****************
 * FILTERS RESET *
 *****************/


function FiltersReset() {
  console.log("Reset");
  $(".filter-elem").each(function (index, e) {
    $(e).prop("checked", false);
    $(e).prop("indeterminate", false);
  });
  FiltersOnChange_do();
}

$("#filters-reset").click(function (e) {
  e.preventDefault();
  FiltersReset();
});
/*********************
 * FILTERS ON CHANGE *
 *********************/

function FiltersOnChange() {
  console.log("%cfunction FiltersOnChange()", "color: teal");
  $(".filter-elem").change(function (e) {
    e.preventDefault();
    $(e).prop("checked", true);
    FiltersOnChange_do();
    FiltersCollapseController();
  });
}

function FiltersOnChange_do() {
  console.log("%cfunction FiltersOnChange_do()", "color: teal");
  u.clearQuery();
  $(".filter-elem:checked").each(function (index, element) {
    var fType = $(element).attr("data-filter");
    var fVal = $(element).val();

    if (typeof u.query[fType] == "undefined") {
      u.query[fType] = [];
    }

    if (u.query[fType] instanceof Array) {
      // the way to add a parameter
      u.query[fType].push(fVal); // now it's "a=1&a=2&a=3&a=4&b=woohoo"
    }

    if ($(element).attr("data-area")) {
      var ar = $(element).attr("data-area");
      console.log("data-area", ar);

      if (!u.query["area"] || !u.query["area"].indexOf(ar)) {
        /* temporary disabled
        if (typeof u.query["area"] == "undefined") {
          u.query["area"] = []
        }
        u.query["area"].push(ar)
        */
      }
    } // if ($(element).attr("data-sottoarea")) {
    //   var sa = $(element).attr("data-sottoarea")
    //   if (!u.query["sottoarea"] || !u.query["sottoarea"].indexOf(sa)) {
    //     if (typeof u.query["sottoarea"] == "undefined") {
    //       u.query["sottoarea"] = []
    //     }
    //     u.query["sottoarea"].push(sa)
    //   }
    // }

  });
  u.render();
  Crawl();
}

function FiltersCollapseController() {
  $(".filter-elem").each(function (i, elem) {
    var $input = $(elem);
    var $formCheck = $(elem).closest(".form-check");
    var $icon = $formCheck.find(".fa-chevron-right");
    var controls = $formCheck.attr("href");
    var checked = $input.prop("checked");

    if (checked) {
      $(controls).collapse("show");
      $formCheck.attr("aria-expanded", "true");
      $icon.addClass("fa-rotate-90");
    } else {
      $(controls).collapse("hide");
      $formCheck.attr("aria-expanded", "false");
      $icon.removeClass("fa-rotate-90");
    }
  });
}
/*****************
 * FILTERS ALIGN *
 * make filters follow url changes
 *****************/


function FiltersAlign() {
  console.group("function FiltersAlign()");
  var url = u.query;
  var qKeys = Object.keys(url);
  console.log(qKeys);
  console.log("-END QKEYS-");
  var query = window.hgObject.wpQuery.filterQuery;
  console.log(query); // $.each(query, function (k, v) {
  //   var tempK = ['area', 'sottoarea', 'localita']
  //   if (tempK.includes(k)) {
  //     $(".filter-elem[data-filter='" + k + "']").each(function (i, e) {
  //     });
  //   }
  // });

  $.each(qKeys, function (i, key) {
    $(".filter-elem[data-filter='" + key + "']").each(function (i, e) {
      var _this = this;

      if (url[key].includes($(e).val())) {
        console.log("filter includes", this);
        setTimeout(function () {
          console.log("triggered");
          $(_this).prop("checked", true);
        }, 100);
      }
    });
  });
  console.groupEnd();
}
/*********
 * GO TO *
 *********/


function GoTo(page, data, urlDefined) {
  if (!urlDefined) {
    var urlList = window.hgObject.pages.list_cataloghi_attuale;
    var urlShow = window.hgObject.catalogo.attualeUrl;
  } else {
    var urlList = '/cataloghi/' + urlDefined;
    var urlShow = urlDefined;
  }

  var urlBase = window.hgObject.pages[page];
  var s = new _mainFunctions.hgUrl(urlBase);

  if (page == "list") {
    var ss = new _mainFunctions.hgUrl(urlList + "/");
    data.forEach(function (e) {
      ss.query[e[0]] = e[1];
    });
    s = ss;
  } else if (page == "show") {
    s.paths([window.hgObject.pages.show_relative.split("/").join(""), urlShow, data.id, data.nome]);
  } // console.log(data);
  // console.log(s);
  // alert(urlDefined)
  // alert(urlUsed)
  // var r = confirm(s + "\n\r Premere OK per visitare la pagina");
  // if (r == true) {
  //   window.location.href = s;
  // } else {
  //   txt = "You pressed Cancel!";
  // }
  // alert(s)


  window.location.href = s;
}
/**********
 * SEARCH *
 **********/


function searchInit(isListPage) {
  var isListPage = isListPage ? isListPage : false;

  if (isListPage) {
    $(".search-button").click(function (e) {
      e.preventDefault();
      $(".strutture-search #search-container-inner").addClass("active");
      $(".strutture-search #search-container-inner .easy-autocomplete").css("width", "100%");
    });
  }

  (0, _mainFunctions.getJSON)("strutture", function (strutture) {
    // console.log("GETJSON");
    // console.log(strutture);
    (0, _mainFunctions.getJSON)("zone", function (zone) {
      console.log(zone);
      $.each(zone["areaTuristica"], function (indexInArray, area) {
        strutture.push({
          id: area.id,
          nomeStruttura: area.nome,
          type: "area"
        });
        $.each(area.SottoArea, function (indexInArray, sottoarea) {
          strutture.push({
            id: sottoarea.id,
            nomeStruttura: sottoarea.nome,
            nome_area: area.nome,
            id_area: area.id,
            type: "sottoarea"
          });
          $.each(sottoarea["localita"], function (indexInArray, localita) {
            strutture.push({
              id: localita.id,
              nomeStruttura: localita.nome,
              nome_area: area.nome,
              id_area: area.id,
              nome_sottoarea: sottoarea.nome,
              id_sottoarea: sottoarea.id,
              type: "localita"
            });
          });
        });
      });
      console.log(strutture);
      $("#search").easyAutocomplete({
        // url: [
        //   "data/strutture.json",
        //   "data/zone  .json"
        // ],
        data: strutture,
        getValue: function getValue(element) {
          // console.log(element);
          return element.nomeStruttura;
        },
        list: {
          match: {
            enabled: true
          },
          onShowListEvent: function onShowListEvent() {
            $("#search").addClass("open");
          },
          onHideListEvent: function onHideListEvent() {
            $("#search").removeClass("open");
          },
          onChooseEvent: function onChooseEvent() {
            var elem = $("#search").getSelectedItemData();

            if (elem.type == "area") {
              GoTo("list", [["area", elem.id]], isListPage);
            } else if (elem.type == "sottoarea") {
              GoTo("list", [["area", elem.id_area], ["sottoarea", elem.id]], isListPage);
            } else if (elem.type == "localita") {
              GoTo("list", [["area", elem.id_area], ["sottoarea", elem.id_sottoarea], ["localita", elem.id]], isListPage);
            } else {
              GoTo("show", {
                id: elem.id_struttura,
                nome: elem.nomeStruttura
              }, isListPage); // gotoStruttura(elem.id_struttura)
            }
          }
        },
        template: {
          type: "custom",
          method: function method(value, element) {
            if (element.type == "area") {
              var desc = "";
              var icon = '<i class="fas fa-tree"></i>';
            } else if (element.type == "sottoarea") {
              var desc = element.nome_area;
              var icon = '<i class="fab fa-pagelines"></i>';
            } else if (element.type == "localita") {
              var desc = element.nome_area + " / " + element.nome_sottoarea;
              var icon = '<i class="fas fa-map-marker-alt"></i>';
            } else {
              var desc = element.nome_area + " / " + element.nome_sottoarea + " / " + element.nome_localita;
              var icon = '<i class="fas fa-concierge-bell"></i>';
            }

            return '<span class="search-icon">' + icon + "</span><span class='s-1'>" + value + '</span><span class="description">' + desc + "</span>";
          }
        },
        theme: "square"
      });
    });
  });
} //
// ────────────────────────────────────────────────────────── I ──────────
//   :::::: S T R U T T U R A : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────
//


function strutturaGet() {
  DatafolderAlign();
  (0, _mainFunctions.getJSON)("strutture", function (r) {
    console.log(r); // r = FiltersDo(r)

    r = strutturaFilter(r);
    strutturaRender(r);
    strutturaDesc();
    strutturaMappa();
    TooltipsInit();
    LoaderHide();
  });
}

function strutturaFilter(resp) {
  // var u = new Url();
  // var struttura = resp.filter(r => r.id_struttura == u.query.struttura)[0]
  var struttura = resp.filter(function (r) {
    return r.id_struttura == window.hgObject.wpQuery.idStruttura;
  })[0];
  return struttura;
}

function strutturaRender(resp) {
  if (typeof resp == "undefined") window.location.href = "/404/";
  console.log("%cRESP", "color: green", resp);
  $.getJSON("data/servizi.json", "", function (data, textStatus, jqXHR) {
    console.log("SERVIZI JSON DATA", data);
    return data;
  });

  if (resp.length == 0) {
    // $("#list-messages").find(".no-strutture").css("visibility", "visible")
    alert("nessuna struttura");
  } else {
    var e = resp;
    console.log("e.servizi.ser", e.servizi.ser);
    var data = {
      "#struttura-stelle": {
        content: echoStars(e.id_categoria)
      },
      "#struttura-nome": {
        content: "<h1>" + e.nomeStruttura + "</h1>"
      },
      "#struttura-localita": {
        // content: "<h2>" + e.nome_localita + ", " + e.nome_sottoarea + ", " + e.nome_area + " - " + e.altitudine + "mt</h2>"
        content: "<h2>".concat(e.nome_area, " - ").concat(e.nome_localita, " (").concat(e.altitudine, "mt)</h2>")
      },
      "#struttura-img": {
        content: e.immagini[0],
        image: false,
        background: true,
        imgProvider: "http://img.thol.it/?",
        imgSize: "large"
      },
      "#struttura-descrizione": {
        content: e.descrizione,
        trim: 300
      },
      "#struttura-mappa": {
        map: true,
        lat: e.latitudine,
        long: e.longitudine
      },
      "#struttura-spots": {
        content: e.spots
      },
      "#struttura-galleria": {
        gallery: true,
        content: e.immagini,
        sizes: {
          thumbnail: {
            provider: "http://img.thol.it/?",
            size: "miniatura1"
          },
          large: {
            provider: "http://img.thol.it/?",
            size: "large"
          }
        },
        options: {
          slider: {
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 2000,
            responsive: [{
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }]
          }
        }
      },
      "#struttura-servizi": {
        customTemplate: "servizi",
        customTemplateVars: {
          idSubstring: "ser"
        },
        content: e.servizi.ser,
        tooltips: true,
        // tooltipsObject: getJSON('servizi', (servizi) => {
        //   return servizi
        // })
        beforeRender: function beforeRender() {
          console.log("WAITING...");
          var noaResp = null;
          (0, _mainFunctions.getJSON)("servizi", function (servizi) {
            noaResp = servizi;
          }, true);
          var filtered = noaResp.filter(function (f) {
            return f.id.includes("ser");
          });
          return filtered;
        }
      },
      "#struttura-clubs": {
        customTemplate: "servizi",
        customTemplateVars: {
          idSubstring: "clp"
        },
        content: e.servizi.clp,
        tooltips: false,
        link: true,
        // tooltipsObject: getJSON('servizi', (servizi) => {
        //   return servizi
        // })
        beforeRender: function beforeRender() {
          console.log("WAITING...");
          var noaResp = null;
          (0, _mainFunctions.getJSON)("servizi", function (servizi) {
            noaResp = servizi;
          }, true);
          var filtered = noaResp.filter(function (f) {
            return f.id.includes("clp");
          });
          return filtered;
        }
      },
      // '#struttura-clubs': {
      //   list: true,
      //   withIcon: 'clubs-icon',
      //   icons: e.servizi,
      //   content: e.servizi.clp,
      //   tooltipsPath: 'servizi',
      //   href: {
      //     baseUrl: window.hgPages.list,
      //     params: [{
      //       key: "club",
      //       value: 'id'
      //     }]
      //   }
      // },
      "#struttura-prezzi": {
        content: e.prezzi,
        // beforeRender: function() {
        //   var contentOut = e.prezzi;
        //   if (
        //     window.hgObject.catalogo.attualeUrl !=
        //     window.hgObject.wpQuery.catalogo
        //   ) {
        //     contentOut =
        //       '<div class="struttura-prezzi-futuro">I prezzi potrebbero subire variazioni</div>' +
        //       contentOut;
        //   }
        //   return {
        //     content: contentOut
        //   };
        // },
        afterRender: function afterRender() {
          console.group("Struttura prezzi after render"); // $('#struttura-prezzi').hide("slow")

          console.groupEnd();
        }
      },
      "#struttura-condizioni": {
        content: e.noteprezzi + "<br/><br/>" + e.supplementi
      },
      "#inputNomeStruttura": {
        inputValue: true,
        content: e.nomeStruttura
      },
      "#inputUrlStruttura": {
        inputValue: true,
        content: u
      }
    }; // $('#hgout_show').hgRender(window.hgPaths.template + '?' + Date.now(), "#struttura", data)

    $("#hgout_show").hgRender(false, "body", data);
  }
}

function echoStars(stars) {
  var out = '<i class="fas fa-star"></i>'.repeat(stars.match(/\d+/)[0]);

  if (stars.includes("s")) {
    out += "S";
  }

  return out;
}

function strutturaDesc() {
  $(".descrizione-collapse").click(function (e) {
    e.preventDefault();
    console.log("%cstrutturaDesc()", "color: teal"); // $(".descrizione-trimmed, .descrizione-full").toggle()

    $(".descrizione-collapse").hide();
    $(".descrizione-content").addClass("full");
  });
}

function strutturaMappa() {
  var map;

  if ($("#struttura-mappa").length) {
    var lat = parseFloat($("#struttura-mappa .struttura-mappa-values").attr("data-lat").replace(",", "."));
    var long = parseFloat($("#struttura-mappa .struttura-mappa-values").attr("data-long").replace(",", "."));
    map = new google.maps.Map(document.getElementById("struttura-mappa"), {
      center: {
        lat: lat,
        lng: long
      },
      disableDefaultUI: true,
      zoom: 12
    });
    var marker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: long
      },
      map: map
    });
  }
} // console.log("test ie es6");
// setTimeout(() => {
//   console.log("WORKS!");
// }, 1000);


function LoaderShow() {
  $("#loader").css("opacity", 1);
  $("#loader-container").show("slow");
}

function LoaderHide() {
  $("#loader").css("opacity", 0);
  $("#loader-container").hide("slow");
}

function TooltipsInit() {
  console.log("%cTooltips init", "color: teal");
  $('[data-toggle="tooltip"]').tooltip();
}

function CountRender(resp) {
  $(".strutture-count").text(resp.length);
}

function Debug(resp, initial) {
  $("#debug div").empty(); // $(".strutture-count").text(resp.length + "/" + initial)

  var aree = [],
      total = 0;
  $.each(resp, function (indexInArray, re) {
    aree.includes(re.nome_area) ? function () {} : aree.push(re.nome_area);
    $("#debug .full").append("<div>" + re.nome_area + "</div>");
    total++;
  });
  $("#debug .total").text(total);
  $.each(aree, function (indexInArray, a) {
    $("#debug .aree").append("<div>" + a + "</div>");
  }); // $.each(resp, function (indexInArray, r) {
  //   if (typeof r.servizi.clp != "undefined") {
  //     $.each(r.servizi.clp, function (indexInArray, s) {
  //       console.log(s.id);
  //     });
  //   }
  // });
} // console.groupEnd()

},{"./main.functions.js":2,"./main.vars.js":4,"is-mobile":1}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = void 0;
var icons = {
  servizi: {
    AV: "/src/img/servizi/cane.svg",
    VB: "/src/img/servizi/sedia-a-rotelle.svg",
    PI: "/src/img/servizi/nuoto.svg",
    CB: "/src/img/servizi/massaggio.svg",
    MC: "/src/img/servizi/bambini.svg",
    MI: "/src/img/servizi/celiaci.svg",
    SP: "/src/img/servizi/sci.svg",
    ZB: "/src/img/servizi/candela.svg",
    AN: "/src/img/servizi/animazione.svg"
  }
};
exports.icons = icons;

},{}]},{},[3,2]);
